import { RESET_APP, RESET_CART } from '../actions';
import {
  RECEIVE_SEQUENCES,
  SELECT_SEQUENCE,
  SEQUENCE_STEP_FORWARD,
  SEQUENCE_STEP_BACK,
  CLEAR_SELECTED_SEQUENCE
} from '../actions/sequence';

const initialState = {
  sequencesData: [],
  selectedSequence: null,
  inSequence: false,
  sequenceStep: 0,
  goingForward: true
};


export default (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_SEQUENCES:
      return {
        ...state,
        sequencesData: action.sequences
      }
    case RESET_CART:
    case RESET_APP:
      return { ...initialState };
    case SELECT_SEQUENCE:
      return {
        ...state,
        selectedSequence: action.sequence,
        inSequence: true
      };
    case SEQUENCE_STEP_FORWARD:
      return {
        ...state,
        sequenceStep: state.sequenceStep + 1,
        goingForward: true
      };
    case SEQUENCE_STEP_BACK:
      return {
        ...state,
        sequenceStep: state.sequenceStep - 1,
        goingForward: false
      };
    case CLEAR_SELECTED_SEQUENCE:
      return {
        ...state,
        selectedSequence: null,
        inSequence: false,
        sequenceStep: 0
      };
    default:
      return state;
  }
}
